import { getLabelPrintBatchById } from "@client-shared/services/api/batches";
import type { LabelPrintBatchDetail } from "@shared/types";
import { useQuery } from "@tanstack/react-query";

const BATCH_DETAILS_STALE_TIME = 30_000;

interface BatchDetailsResult {
  readonly batch: LabelPrintBatchDetail | undefined;
  readonly isLoading: boolean;
}

export function useBatchDetails(batchId: string | undefined): BatchDetailsResult {
  const { data, isLoading } = useQuery({
    queryKey: ["batchDetails", batchId],
    queryFn: async () => {
      if (!batchId) {
        throw new Error("batchId is required");
      }
      const result = await getLabelPrintBatchById(batchId);
      return result.data;
    },
    enabled: Boolean(batchId),
    staleTime: BATCH_DETAILS_STALE_TIME,
    retry: 1,
  });

  return { batch: data ?? undefined, isLoading };
}
